import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  market: null,
  loading: false,
};

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const market = data;

  return {
    ...state,
    market,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
